import { Component } from '@angular/core';
import { ChildDataTableDirective } from '../../../../shared/directives/child-data-table.directive';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ColumnConfig } from '../../../../shared/models/column-config.model';
import { AuthService } from '../../../../shared/services/auth.service';
import { NotificationService } from '../../../../shared/services/notification.service';
import { PageStateManagerService } from '../../../../shared/services/page-state-manager.service';
import { TitleService } from '../../../../shared/services/title.service';
import { AuditService } from '../../services/audit.service';
import { Observable, combineLatest, switchMap, EMPTY } from 'rxjs';
import { ResultSet } from '../../../../shared/models/result-set.model';
import { AuditItem } from '../../models/audit-item.model';
import { AuditItemService } from '../../services/audit-item.service';

@Component({
  selector: 'app-audit-items',
  standalone: false,
  templateUrl: './audit-items.component.html',
  styleUrl: './audit-items.component.scss'
})
export class AuditItemsComponent extends ChildDataTableDirective<AuditItem> {
  override modelName: string = 'Audit Log';
  override columns: ColumnConfig[] = [];

  constructor(   
    private auditService: AuditService, 
    auditItemService: AuditItemService,    
    fb: FormBuilder, 
    route: ActivatedRoute, 
    router: Router, 
    titleService: TitleService,
    notificationService: NotificationService,
    pageStateManager: PageStateManagerService,
    authService: AuthService,
  ) {
    super(
      auditItemService, 
      fb, 
      route, 
      router, 
      titleService, 
      notificationService,
      pageStateManager,
      authService
    );       
  }

  override ngOnInit(): void {
    this.columns = [
      { name: 'fieldName', label: 'Column', inputType: 'none' },
      { name: 'oldValue', label: 'Old Value', inputType: 'none' },
      { name: 'newValue', label: 'New Value', inputType: 'none' },
    ]
    this.route.paramMap.subscribe(params => {
      const parentId = params.get('auditId')!;
      this.parentID = parseInt(parentId);      
    });   
    super.ngOnInit(); 
  } 
    
  protected override buildResultSet$(): Observable<ResultSet<AuditItem>> {    
    return combineLatest([
          this.currentPageSubject,
          this.pageSizeSubject
        ]).pipe(          
          switchMap(([page, size]) => {
            if(!this.parentID) {
              console.error('Parent ID not set');
              return EMPTY
            }
            const offset = (page - 1) * size;            
            return this.auditService.getAuditItems(this.parentID, offset, size);
          })
        );
  }

  override onGoBack() {
    this.router.navigate(['admin/audit-log']);
  }
}
